import React, { forwardRef } from "react";

import { DisplayNumberProps } from "./types";
import { formatNumber } from "../../utils";
import { Tooltip } from "../Tooltip";
import { Typography } from "../Typography/Typography";

export const DisplayNumber = forwardRef<HTMLSpanElement, DisplayNumberProps>(
  (
    {
      value,
      variant = "Body 2",
      thousandSeparator = ",",
      decimalSeparator = ".",
      trimDecimals = true,
      decimalSpaces = 2,
      format = "long",
      disableTooltip = false,
      className,
      as = "span",
      ...rest
    },
    ref
  ) => {
    const formattedValue = formatNumber(
      value,
      thousandSeparator,
      decimalSeparator,
      trimDecimals,
      decimalSpaces,
      format
    );

    const formattedLongValue = formatNumber(
      value,
      thousandSeparator,
      decimalSeparator,
      trimDecimals,
      decimalSpaces,
      "long"
    );

    if (format === "short") {
      return (
        <Tooltip
          title={formatNumber(
            value,
            thousandSeparator,
            decimalSeparator,
            false,
            decimalSpaces,
            "long"
          )}
          disable={
            disableTooltip ||
            (!formattedLongValue.includes(thousandSeparator) &&
              !formattedLongValue.includes(decimalSeparator))
          }
        >
          <Typography
            as={as}
            variant={variant}
            className={className}
            ref={ref}
            {...rest}
          >
            {formattedValue}
          </Typography>
        </Tooltip>
      );
    }

    return (
      <Typography
        as={as}
        variant={variant}
        className={className}
        ref={ref}
        {...rest}
      >
        {formattedLongValue}
      </Typography>
    );
  }
);

DisplayNumber.displayName = "DisplayNumber";
